import { TASK_COLORS } from './cva';
export const getQuestCSSVariable = (type) => {
    return TASK_COLORS[type];
};
